import { render, staticRenderFns } from "./Product1688.vue?vue&type=template&id=7451c51e&scoped=true"
import script from "./Product1688.vue?vue&type=script&lang=js"
export * from "./Product1688.vue?vue&type=script&lang=js"
import style0 from "./Product1688.vue?vue&type=style&index=0&id=7451c51e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7451c51e",
  null
  
)

export default component.exports